import React, { useState } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import * as R from "ramda";
import { idx_data_axistilt } from "../db/datafixtures/datafixtures";
import { connect } from "react-redux";
import moment from "moment";
import { validateValue } from "../../utils/utils";
import {
  Pencil,
  ClockHistory,
  ChevronDown,
  ChevronUp,
} from "react-bootstrap-icons";
import { getPhotoForUserId } from "../../utils/utils";
import GalleryModal from "../ui/GalleryModal";
import {
  setCustomer,
  setCustomerGallery,
  deleteCustomerGallery,
  papGetAuditRecords,
} from "../bowlers/bowlers.redux";
import BowlerDataModal from "../ui/BowlerDataModal";
import ModalPAPAudit from "../modal/ModalPAPAudit";

const nameStyle = {
  verticalAlign: "middle",
  display: "flex",
  textAlign: "center",
  justifyContent: "center",
  fontSize: "14px",
  fontWeight: "900",
  color: "#000000",
  marginLeft: "20px",
};
const ContainerMod = styled.div`
  display: flex;
  justify-content: start;
  padding: 0;
  margin-bottom: 2vh;
  min-width: "25%";
  width: "25%";
  height: unset;
  margin: 1%;
`;

const GalleryContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: start;
  padding: 0;
  width: 90%;

  ${(props) =>
    props.portrait &&
    css`
      display: none;
    `};
`;

const BowlerTable = ({
  bowler,
  arsenal_layout_style,
  setCustomer,
  specsheetSVGClick,
  isReadOnly,
  isRightHander,
  setCustomerGallery,
  deleteCustomerGallery,
  userId,
  pluginSubscriptions,
  papGetAuditRecords,
  section = "both",
}) => {
  const [t] = useTranslation();
  const [showData, setShowData] = useState(false);
  const [showGallery, setShowGallery] = useState(false);
  const [srcToShow, setSrcToShow] = useState("");
  const [showSubModal, setShowSubModal] = useState(false);
  const [ogSRC, setOGSRC] = useState("");
  const [imageIndex, setImageIndex] = useState(-1);
  const [galleryCollapsed, setGalleryCollapsed] = useState(true);
  const getPhoto = getPhotoForUserId(userId);
  const currentTime = new Date();
  const formattedDate = moment(currentTime).format("YYYYMMDD");
  const values = {
    tables: {
      hand: bowler.hand,
      style: bowler.style || "traditional",
      pap: `${validateValue(bowler.pap_h)} X ${validateValue(bowler.pap_v)} ${
        validateValue(bowler.pap_u_d || bowler.pap_ud) === "Up"
          ? "▲"
          : validateValue(bowler.pap_u_d || bowler.pap_ud) === "Down"
          ? "▼"
          : validateValue(bowler.pap_u_d || bowler.pap_ud) === "-"
          ? "-"
          : ""
      }`,
      axis_rot: bowler.axis_rot,
      axis_tilt: bowler.axis_tilt,
      ball_speed: bowler.ball_speed || "average",
      rev_rate: bowler.rev_rate || "average",
    },
  };

  const {
    tables: { hand, style, pap, axis_rot, axis_tilt, ball_speed, rev_rate },
  } = values;

  const getTiltDegree = (tilt) => {
    const tiltObj = R.find(R.propEq("tilt_measure", tilt), idx_data_axistilt);

    return tiltObj ? tiltObj.tilt_deg : "";
  };

  const groupFilesByDate = (fileNames) => {
    const groupedFiles = {};
    fileNames.forEach((fileName) => {
      const match = fileName.match(/\d{8}/);
      const date = match ? match[0] : "Unknown Date";
      if (!groupedFiles[date]) {
        groupedFiles[date] = [];
      }
      groupedFiles[date].push(fileName);
    });
    return groupedFiles;
  };
  const groupIndexesByDate = (fileNames) => {
    const groupedIndexes = {};
    let counter = 0;
    fileNames.forEach((fileName) => {
      const match = fileName.match(/\d{8}/);
      const date = match ? match[0] : "Unknown Date";
      if (!groupedIndexes[date]) {
        groupedIndexes[date] = [];
      }
      groupedIndexes[date].push(counter);
      counter++;
    });
    return groupedIndexes;
  };
  const groupedFiles = bowler.gallery ? groupFilesByDate(bowler.gallery) : [];
  const groupedIndexes = bowler.gallery
    ? groupIndexesByDate(bowler.gallery)
    : [];
  const GalleryCard = ({ src, key, onClick }) => {
    const srcToCheck = src?.toLowerCase().split("?")[0] || "";
    const isImage =
      srcToCheck.includes("data:image") ||
      ["png", "jpg", "jpeg"].includes(srcToCheck.split(".").pop());
    const isVideo =
      srcToCheck.includes("data:video") ||
      ["mp4", "mov"].includes(srcToCheck.split(".").pop());

    const parts = src.split("_");
    const tag = parts[6];
    return (
      <div onClick={onClick}>
        <div
          style={{
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          #{tag === "" ? t("No tag") : tag}
        </div>
        <div
          style={{
            height: "98%",
            margin: 5,
          }}
        >
          {isImage && (
            <img
              src={getPhoto(`${src}?ttl=${Date().toString()}`)}
              style={{ width: "95px", height: "95px" }}
            />
          )}
          {isVideo && (
            <video
              src={getPhoto(`${src}?ttl=${Date().toString()}`)}
              style={{ width: "95px", height: "95px", pointerEvents: "none" }}
              controls
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <div style={{ width: "100%" }}>
      {(section === "both" || section === "data") && (
        <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#E2E2E2",
          width: "100%",
          maxWidth: "100vw",
          height: "30px",
        }}
      >
        <span style={nameStyle}>{t("form.label.bowlerData")}</span>
        {pluginSubscriptions.indexOf("BOWLER_PLUS") >= 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#E2E2E2",
              flexDirection: "row",
              marginRight: "42px",
              width: "65px",
            }}
          >
            <button
              style={{
                color: "#00187e",
                backgroundColor: "transparent",
                border: "none",
              }}
              onClick={() => {
                papGetAuditRecords({ customerId: bowler.id });
              }}
            >
              <ClockHistory />
            </button>

            <button
              style={{
                color: "#00187e",
                backgroundColor: "transparent",
                border: "none",
              }}
              onClick={() => {
                setShowData(true);
              }}
            >
              <Pencil />
            </button>
          </div>
        )}
        {pluginSubscriptions.indexOf("BOWLER_PLUS") < 0 && (
          <div>
            <button
              style={{
                color: "#00187e",
                backgroundColor: "transparent",
                border: "none",
                marginRight: "38px",
              }}
              onClick={() => {
                setShowData(true);
              }}
            >
              <Pencil />
            </button>
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            fontSize: "18px",
            backgroundColor: hand === "left_hander" ? "red" : "white",
          }}
        >
          {hand === "left_hander"
            ? t("form.label.left_handed")
            : t("form.label.right_handed")}
        </div>
        <div style={{ fontSize: "16px" }}>
          {style === "traditional"
            ? t("form.label.traditional")
            : style === "two_handed"
            ? t("form.label.two_handed")
            : style === "backup"
            ? t("form.label.backup")
            : style === "helicopter_spinner"
            ? t("form.label.helicopter_spinner")
            : style === "full-roller"
            ? t("form.label.full-roller")
            : style === "thumbless"
            ? t("form.label.thumbless")
            : "Throwing Style"}
        </div>
        <h1 style={{ margin: "5px" }}>
          PAP: {pap.replace("▲", "Up").replace("▼", "Down")}
        </h1>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
            alignItems: "center",
            width: "200px",
          }}
        >
          <span style={{ fontSize: "12px" }}>{t("Rotation") + axis_rot}° </span>

          <div style={{ fontSize: "12px" }}>
            {t("Tilt")} {getTiltDegree(axis_tilt)}°
          </div>
        </div>
        <div style={{ fontSize: "12px" }}>
          {" "}
          {(ball_speed === "average" && rev_rate === "average") ||
          (ball_speed === "fast" && rev_rate === "high") ||
          (ball_speed === "slow" && rev_rate === "low")
            ? t("form.label.match")
            : (ball_speed === "fast" && rev_rate === "average") ||
              (ball_speed === "average" && rev_rate === "low")
            ? t("form.label.speedDominant")
            : (rev_rate === "high" && ball_speed === "average") ||
              (rev_rate === "average" && ball_speed === "slow")
            ? t("form.label.revDominant")
            : ball_speed === "fast" && rev_rate === "low"
            ? t("form.label.highSpeedDominant")
            : ball_speed === "slow" && rev_rate === "high"
            ? t("form.label.highRevDominant")
            : t("form.label.custom")}
        </div>
      </div>
        </>
      )}
      {(section === "both" || section === "gallery") &&
        pluginSubscriptions.indexOf("BOWLER_PLUS") >= 0 && (
        <div style={{ minHeight: "70px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#E2E2E2",
              width: "100%",
              maxWidth: "100vw",
              height: "30px",
            }}
          >
            <span style={nameStyle}>{t("Media Gallery")}</span>
            <div style={{ display: "flex", alignItems: "center", marginRight: "10%" }}>
              <button
                style={{
                  color: "#00187e",
                  backgroundColor: "transparent",
                  border: "none",
                }}
                onClick={() => {
                  setSrcToShow("");
                  setShowSubModal(false);
                  setOGSRC("");
                  setImageIndex(-1);
                  setShowGallery(true);
                }}
              >
                <Pencil />
              </button>
              <button
                style={{
                  color: "#00187e",
                  backgroundColor: "transparent",
                  border: "none",
                }}
                onClick={() => setGalleryCollapsed((c) => !c)}
                title={galleryCollapsed ? t("Expand") : t("Collapse")}
                aria-label={galleryCollapsed ? t("Expand") : t("Collapse")}
              >
                {galleryCollapsed ? <ChevronDown /> : <ChevronUp />}
              </button>
            </div>
          </div>
          {!galleryCollapsed && Object.keys(groupedFiles)
            .sort((a, b) => b.localeCompare(a))
            .map((date, id) => (
              <div
                style={{
                  display: "flex",
                  border: "solid",
                  borderColor: "grey",
                  borderWidth: "1px 0 1px 0",
                }}
                key={date}
              >
                <div
                  style={{
                    display: "flex",
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {date === formattedDate
                    ? t("Today")
                    : date.slice(0, 4) +
                      "/" +
                      date.slice(4, 6) +
                      "/" +
                      date.slice(6, 8)}
                  :
                </div>
                <GalleryContainer>
                  {groupedFiles[date].map((src, index) => (
                    <ContainerMod>
                      <GalleryCard
                        src={src}
                        key={index}
                        onClick={() => {
                          setSrcToShow(
                            getPhoto(`${src}?ttl=${Date().toString()}`)
                          );
                          setShowSubModal(true);
                          setOGSRC(src);
                          setShowGallery(true);
                          setImageIndex(groupedIndexes[date][index] || 0);
                        }}
                      />
                    </ContainerMod>
                  ))}
                </GalleryContainer>
              </div>
            ))}
        </div>
      )}

      {(section === "both" || section === "gallery") && showGallery && (
        <GalleryModal
          showGalleryModal={showGallery}
          setShowGalleryModal={setShowGallery}
          gallery={bowler?.gallery}
          setCustomerGallery={setCustomerGallery}
          deleteCustomerGallery={deleteCustomerGallery}
          srcToShowDefault={srcToShow}
          showModalDefault={showSubModal}
          ogSRCDefault={ogSRC}
          imageIndexDefault={imageIndex}
          userId={userId}
          customerID={bowler?.id}
        ></GalleryModal>
      )}
      {(section === "both" || section === "data") && showData && (
        <BowlerDataModal
          showData={showData}
          setShowData={setShowData}
          bowler={bowler}
          isReadOnly={isReadOnly}
          setCustomer={setCustomer}
          isRightHander={isRightHander}
          specsheetSVGClick={specsheetSVGClick}
        />
      )}
      {(section === "both" || section === "data") && <ModalPAPAudit />}
    </div>
  );
};

export default connect(
  (state) => ({
    bowler: state.bowlers.selectedCustomer,
    userId: state.userSession.userData.id,
    isReadOnly: state.userSession.isReadOnly,
    pluginSubscriptions: state.plugin.pluginSubscriptions,
    isRightHander: state.specsheet.currentSpecSheet
      ? state.specsheet.currentSpecSheet.hand === "right_hander"
      : true,
  }),
  { setCustomer, setCustomerGallery, deleteCustomerGallery, papGetAuditRecords }
)(BowlerTable);
